Ext.define('SA.AcsTable.DefaultView', {
    alias: 'widget.acs-default-view',
    extend: 'SA.view.SimpleContainer',

    items: [
        {
            xtype: 'load-mask',
            itemId: 'loadMask'
        }, {
            xtype: 'component',
            itemId: 'tableContainer',
            cls: 'sa-acs-default-view-table-container'
        }
    ]
});